import { FadeUp, Overline } from "./Reveal";

const STEPS = [
  {
    title: "Product Enquiry",
    copy: "Buyer selects products and shares requirements.",
  },
  {
    title: "Product & Packaging Discussion",
    copy: "Discuss specifications, packaging and branding requirements.",
  },
  {
    title: "Quotation",
    copy: "Provide commercial details based on buyer requirements.",
  },
  {
    title: "Order Confirmation",
    copy: "Finalize product and order requirements.",
  },
  {
    title: "Preparation & Packaging",
    copy: "Products are prepared according to agreed requirements.",
  },
  {
    title: "Shipment",
    copy: "Coordinate the shipment process for delivery.",
  },
];

export default function HowWeWork() {
  return (
    <section id="process" data-testid="process-section" className="bg-white py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <FadeUp className="max-w-2xl">
          <Overline>How We Work</Overline>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-navy md:text-5xl">
            A clear path from enquiry to shipment.
          </h2>
        </FadeUp>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="process-grid">
          {STEPS.map((step, i) => (
            <FadeUp key={step.title} delay={i * 0.06}>
              <article
                data-testid={`process-step-${i + 1}`}
                className="group h-full rounded-2xl border border-navy/10 bg-white p-8 transition-[transform,border-color,background-color] duration-300 hover:-translate-y-1 hover:border-gold hover:bg-cream"
              >
                <p className="font-display text-sm font-semibold tracking-[0.18em] text-gold-dark">
                  STEP {i + 1}
                </p>
                <h3 className="mt-4 font-display text-xl font-semibold uppercase tracking-tight text-navy">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-navy/65">{step.copy}</p>
              </article>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
